export type NotificationType =
  | 'stamp_earned'
  | 'reward_unlocked'
  | 'reward_reminder'
  | 'reward_expiring_soon'
  | 'birthday'
  | 'referral_bonus'
  | 'welcome'

export interface Notification {
  id: string
  member_id: string
  type: NotificationType
  title: Record<string, string>
  body: Record<string, string>
  is_read: boolean
  related_entity_id: string | null
  created_at: string
}

export interface NotificationGroup {
  label: string
  entries: Notification[]
}
